import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { SubscriptionService } from './subscription.service';

angular.module('app-lite.subscriptions', [])
  .service('subscriptionApi', downgradeInjectable(SubscriptionService));
